/**
 * Avalara © 2017
 * file: engines/opus_ui/src/actions/cases.js
 */

import axios from 'axios';
import config from '../config';
import { getBaseUrlFromConfig } from '../utils/url_helpers';
import { push } from 'react-router-redux';

export const UPDATE_CASE_REQUEST = 'UPDATE_CASE_REQUEST';
export const UPDATE_CASE_SUCCESS = 'UPDATE_CASE_SUCCESS';
export const UPDATE_CASE_FAILURE = 'UPDATE_CASE_FAILURE';
export const FETCH_CASES_REQUEST = 'FETCH_CASES_REQUEST';
export const FETCH_CASES_SUCCESS = 'FETCH_CASES_SUCCESS';
export const FETCH_CASES_FAILURE = 'FETCH_CASES_FAILURE';

export function updateCase(obligationDetail, caseId, customerAccountId) {
  return (dispatch, getState) => {
    // let token = getState().auth.token;
    dispatch(updateCaseRequest());
    return updateCaseWithChargeNumber(
      dispatch,
      // token,
      obligationDetail,
      caseId,
      customerAccountId
    );
  };
}

function updateCaseWithChargeNumber(
  dispatch,
  // token,
  obligationDetail,
  caseId,
  customerAccountId
) {
  const updateCancellationCaseURL = `${getBaseUrlFromConfig(
    config.biztechApi
  )}/customer/cases`;
  return axios
    .put(
      `${updateCancellationCaseURL}/${caseId}`,
      { obligationDetail },
      {
        headers: {
          // authorization: `Bearer ${token}`,
          'content-type': 'application/json',
        },
      }
    )
    .then((res) => dispatch(updateCaseSuccess(dispatch, customerAccountId)))
    .catch(() => dispatch(updateCaseFailure(obligationDetail)));
}

function updateCaseRequest() {
  return { type: UPDATE_CASE_REQUEST };
}

function updateCaseSuccess(dispatch, customerAccountId) {
  dispatch(push(`/search?query=${customerAccountId}`));
  return { type: UPDATE_CASE_SUCCESS };
}

function updateCaseFailure() {
  return { type: UPDATE_CASE_FAILURE };
}

export function fetchCases(customerAccountId) {
  return (dispatch, getState) => {
    // let token = getState().auth.token;
    dispatch(fetchCasesRequest());
    return fetchCancellationCasesForCustomer(
      dispatch,
      // token,
      customerAccountId
    );
  };
}

function fetchCancellationCasesForCustomer(dispatch, customerAccountId) {
  const fetchCancellationCasesURL = `${getBaseUrlFromConfig(
    config.biztechApi
  )}/customer/cases?status=Confirmed&ownerId=00G33000002NU7zEAG&customerAccountId=${customerAccountId}&approvedByBilling=true`;
  return axios
    .get(fetchCancellationCasesURL, {
      headers: {
        // authorization: `Bearer ${token}`,
        'content-type': 'application/json',
      },
    })
    .then((res) => dispatch(receiveCasesSuccess(res.data.data || [])))
    .catch(() => dispatch(receiveCasesFailure()));
}

function fetchCasesRequest() {
  return { type: FETCH_CASES_REQUEST };
}

function receiveCasesSuccess(data) {
  let cancellationPending = false;
  if (data.length > 0) cancellationPending = true;
  return { type: FETCH_CASES_SUCCESS, cancellationPending };
}

function receiveCasesFailure() {
  return { type: FETCH_CASES_FAILURE };
}
